let baseUrl = '';
switch (process.env.NODE_ENV) {
  case 'development':
  // baseUrl = "http://172.145.0.77:8088"  //这里是本地的请求url
  // baseUrl = "//172.145.0.77:8089"
    // baseUrl = '//172.145.0.157:8888'
    baseUrl = 'https://api.java.sauos.com'
    break
  case 'production':
    baseUrl = '//api.java.sauos.com' // 生产环境url
    break
}
export default baseUrl;
